import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import AppValues from '../../app.values';

@Pipe({
  name: 'replaceBrokenUrls',
})
export class ReplaceBrokenUrlsPipe implements PipeTransform {
  public urls: string[] = [];

  private domSanitizer = inject(DomSanitizer);

  /**
   * @description Сhecks the link to the image and returns a promise.
   * @param { string } url
   * @returns { Promise<HTMLImageElement | boolean> }
   */

  public isImgUrl(url: string): Promise<HTMLImageElement | boolean> {
    const img: HTMLImageElement = new Image();
    img.src = url;
    return new Promise(
      (resolve: (value?: PromiseLike<HTMLImageElement | boolean> | HTMLImageElement | boolean) => void) => {
        img.onerror = () => resolve(img);
        img.onload = () => resolve(false);
      },
    );
  }

  /**
   * @description If none of the images are removed, the same input value is returned
   * without transformation. If part of the image has been deleted, the converted value is returned,
   * replacing the deleted images with a pre-prepared image or passed to a parameter.
   * @param { string } value
   * @param { string } icon
   * @returns { Promise<SafeHtml> }
   */

  public transform(value: string, icon: string = AppValues.warningImage): Promise<SafeHtml> {
    if (value.search(/<img.+?>/) === -1) {
      return Promise.resolve(this.domSanitizer.bypassSecurityTrustHtml(value));
    }

    const imagesArray: string[] = value.match(/<img.+?>/g);

    imagesArray.map((item: string) => {
      const url: string = item.match(/http.+?"/)[0].slice(0, -1);
      this.urls.push(url);
      return item;
    });

    return Promise.all(this.urls.map((url: string) => this.isImgUrl(url))).then(
      (data: (HTMLImageElement | boolean)[]) => {
        const filteredArray: HTMLImageElement[] = data.filter(Boolean) as HTMLImageElement[];
        if (filteredArray.length === 0) {
          return Promise.resolve(this.domSanitizer.bypassSecurityTrustHtml(value));
        }

        filteredArray.map((item: HTMLImageElement) => {
          const brokenIcon = `src="${icon}" width="45" height="45"`;
          const brokenLink: string = item.outerHTML.match(/src=".+?"/)[0];
          value = value.replace(brokenLink, brokenIcon);
        });
        return this.domSanitizer.bypassSecurityTrustHtml(value);
      },
    );
  }
}
